import $ from 'cash-dom';
import { grabOnInit } from '@core';
import EmblaIntialization from '@common/carousel/embla-initialization';
import isMobile from '@common/utils/is-mobile';
import showMoreDesc from '@common/utils/show-more-v2';
import setTimeoutAsync from '@common/utils/set-timeout';
import BubbleHoverEffect from '@common/utils/bubble-hover-efffect';
import gaSC, { pbGA, pbGA2, npga2 } from '@common/utils/ga';
import { checkIfInViewport } from '@common/events/checkIfInView';

// GA Events
var pageName = $('main').data('ctype');
const ga_ec = {
  page: `All ${pageName}`,
  TopPop: `Popular ${pageName}`,
  Search: 'SearchBox',
  FreshCpns: 'Fresh Coupons',
  PopularMerc: 'Popular Merchants',
  Alpha: 'Alpha Items',
};

$(() => {
  grabOnInit();
  if ($('main').data('ctype') !== 'Merchant') {
    checkIfInViewport();
  }
  toggleDescription();
  showMoreDesc();
  initPopularStoresToggle();
  $("ul[data-type='alpha-ul'] > li").on('click', function () {
    const $t = $(this);
    const activeAttr = 'data-state';
    $('ul[data-type="alpha-ul"] > li').removeAttr(activeAttr);
    $t.attr(activeAttr, 'active');
    var string = $t.text().trim();
    const hideAttr = 'data-visible';
    const animAttr = 'data-filtered';
    const colChangedAnimAttr = 'data-col-count-changed';
    const outputEle = $("div[data-type='output-div'] a");
    if (string) {
      outputEle.removeAttr(colChangedAnimAttr);
      if (string != 'All') {
        string = string.toLowerCase();
        outputEle.each(function (i, ele) {
          var item = $(ele);
          var hashRegex = /^[0-9]{1}/;
          const text = item.find('#alphaFilter').text().toLowerCase().trim();
          var condtion =
            string == '#' ? hashRegex.test(text) : text.indexOf(string) === 0;
          item.attr(hideAttr, condtion ? 'show' : 'hide');
          item.attr(animAttr, `${condtion}`);
        });
      } else {
        outputEle.removeAttr(hideAttr);
        outputEle.removeAttr(animAttr);
        outputEle.removeAttr(colChangedAnimAttr);
      }
      gaSC(
        `${ga_ec.page + ga_ec.Alpha} with ${string}`,
        `${ga_ec.page + ga_ec.Alpha} with ${string}`,
        0,
      );
    }
  });

  // Search Filter
  const searchBox = document.querySelector('div[data-type="search-div"]');
  const searchInput = searchBox?.querySelector('input');

  if (searchInput && searchInput !== null) {
    searchInput.addEventListener('input', (e) => {
      // @ts-ignore
      const value = e.target.value;
      const hideAttr = 'data-visible';
      const activeAttr = 'data-state';
      const animAttr = 'data-filtered';
      const alphaEles = $("ul[data-type='alpha-ul'] > li");
      alphaEles.removeAttr(activeAttr);
      $("ul[data-type='alpha-ul'] > li[data-type='all']").attr(
        activeAttr,
        'active',
      );
      // alphaEles[0].attr(activeAttr, 'active');
      $("div[data-type='output-div'] a").each(function (i, ele) {
        var item = $(ele);
        var hashRegex = /^[0-9]{1}/;
        const text = item.find('#alphaFilter').text().toLowerCase().trim();
        var condtion = text.includes(value.trim().toLowerCase());
        item.attr(hideAttr, condtion ? 'show' : 'hide');
        item.attr(animAttr, `${condtion}`);
      });
    });
  }

  // The icon toggles the box open and closed; on mobile it starts as a
  // circular icon-only button and the click expands it into the input
  // (SCSS: [data-state="active"]), same as the GrabOnINTL reference's
  // AlphabetFilterBar. Closing it also clears whatever was typed, since a
  // hidden filter still narrowing the list with no visible box to explain
  // why is worse than losing the query.
  const searchIcon = searchBox?.querySelector('[data-type="search-icon"]');

  if (isMobile() && searchBox && searchIcon) {
    const activeAttr = 'data-state';

    const setActive = (active) => {
      if (active) {
        searchBox.setAttribute(activeAttr, 'active');
        searchIcon.setAttribute('aria-expanded', 'true');
        searchInput?.focus();
      } else {
        searchBox.removeAttribute(activeAttr);
        searchIcon.setAttribute('aria-expanded', 'false');
        if (searchInput && searchInput.value) {
          searchInput.value = '';
          searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    };

    const toggle = (event) => {
      event.preventDefault();
      event.stopPropagation();
      setActive(searchBox.getAttribute(activeAttr) !== 'active');
    };

    searchIcon.addEventListener('click', toggle);
    searchIcon.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') toggle(event);
    });

    // A click anywhere else closes it — the box has no other way to
    // dismiss once the icon itself is hidden behind the expanded input.
    document.addEventListener('click', (event) => {
      if (searchBox.getAttribute(activeAttr) !== 'active') return;
      if (searchBox.contains(event.target)) return;
      setActive(false);
    });
  }

  // Grid View

  const gridViewEles = document.querySelectorAll(
    'div[data-type="grids-view"] > span',
  );

  gridViewEles.forEach((ele, index) => {
    ele.addEventListener('click', async (e) => {
      const dataStateAttr = 'data-state';
      const isActive = ele.getAttribute(dataStateAttr) === 'active';
      const animAttr = 'data-filtered';
      const outputEle = $("div[data-type='output-div'] a");
      const outputDiv = document.querySelector('div[data-type="output-div"]');
      const outputDivStyleProp = '--_all-store-slide-col-count';
      const colCount = ele.getAttribute('data-count');
      const colChangedAnimAttr = 'data-col-count-changed';

      if (isActive) return;
      $('div[data-type="grids-view"] > span').attr(dataStateAttr, 'inactive');
      ele.setAttribute(dataStateAttr, 'active');
      outputEle.removeAttr(animAttr);
      outputEle.removeAttr(colChangedAnimAttr);
      await setTimeoutAsync(200);
      // @ts-ignore
      outputDiv.style.setProperty(outputDivStyleProp, colCount);
      outputEle.each(function (i, ele) {
        var item = $(ele);
        // item.attr(animAttr, 'true');
        item.attr(colChangedAnimAttr, 'true');
      });
    });
  });

  // Popular Stores Embla Config

  const popularStoreRootNode = document.querySelector('.embla.popular-items');

  if (popularStoreRootNode && popularStoreRootNode !== null) {
    EmblaIntialization({
      rootNode: popularStoreRootNode,
      options: {
        containScroll: isMobile() ? false : 'trimSnaps',
        align: isMobile() ? 'center' : 'start',
      },
      disable: true,
      navigation: {
        show: true,
        prevNode:
          popularStoreRootNode.parentElement.querySelector('.embla__prev'),
        nextNode:
          popularStoreRootNode.parentElement.querySelector('.embla__next'),
        disable: true,
      },
      // @ts-ignore
      pagination: {
        show: true,
        dotsNode:
          popularStoreRootNode.parentElement.querySelector('.embla__dots'),
      },
      slideType: 'All Popular Items',
      // HasSliderClick: true
    });
  }

  // Bubble Hover effect

  const outputEle = $("div[data-type='output-div'] a");
  outputEle.each((i, ele) => {
    const item = $(ele);
    if (item.length > 0) {
      item[0].addEventListener('mouseenter', (event) => {
        BubbleHoverEffect(item[0], event);
      });
    }
  });

  // TrendingMerchants
  /*
    async function TrendingMerchants(){
        const sidebarMainEle = $('section.main-section div.sidebar-ele');
        if(sidebarMainEle && sidebarMainEle.length > 0){
            const trendingMerchantsList = sidebarMainEle.data('trending-merchants');
            if(trendingMerchantsList && trendingMerchantsList !== ''){
                const html = await request.get(goGlobal.WEB_URL + "allstores/getsidebarstoreswithdata?csv=" + trendingMerchantsList);
                if(html){
                    const html$ = $(html.trim());

                    sidebarMainEle.append(html$);
                    initPopularStoresToggle(sidebarMainEle[0]);
                }
            }
        }
    }

    TrendingMerchants();
    */
});

function toggleDescription() {
  $('#gmAllcDesp').on('click', function () {
    $(this).toggleClass('show');
  });
}

const titleSection = $('section.intro-section .title-section');
if (titleSection && titleSection.length > 0) {
  const allLiElments = titleSection.find(
    '.container > div[data-type] > ul > li',
  );
  allLiElments.each((i, ele) => {
    const $ele = $(ele);
    const countEle = $ele.find('.count');
    const rawCountValue = countEle.data('count');
    counterV2(countEle[0], rawCountValue, $ele);
  });
}

function counterV2(element, rawCountValue, $parent) {
  const isAnim = $parent.data('animation') == 'true';
  if (!isAnim) {
    $parent.attr('data-animation', 'true');
  }

  // @ts-ignore
  element.textContent = rawCountValue;
}

function initPopularStoresToggle(rootElement = document) {
  if (!rootElement) return;

  const popularStoresSections = rootElement.querySelectorAll(
    'div[data-type="popular-stores"]',
  );
  if (!popularStoresSections || popularStoresSections.length === 0) return;

  popularStoresSections.forEach((section) => {
    const toggleBtn = section.querySelector(
      'button[data-type="popular-stores-toggle"]',
    );
    if (!toggleBtn || toggleBtn.getAttribute('data-toggle-init') === 'true')
      return;

    toggleBtn.setAttribute('data-toggle-init', 'true');
    toggleBtn.addEventListener('click', () => {
      const defaultVisible = parseInt(
        toggleBtn.getAttribute('data-default-visible') || '6',
        10,
      );
      const shouldExpand = toggleBtn.getAttribute('data-state') !== 'expanded';
      const storeItems = section.querySelectorAll('[data-store-index]');
      const hiddenClass = 'go-popular-store-hidden';

      storeItems.forEach((item) => {
        const itemIndex = parseInt(
          item.getAttribute('data-store-index') || '0',
          10,
        );
        const shouldHide = !shouldExpand && itemIndex > defaultVisible;
        if (shouldHide) {
          item.classList.add(hiddenClass);
        } else {
          item.classList.remove(hiddenClass);
        }
      });

      toggleBtn.setAttribute(
        'data-state',
        shouldExpand ? 'expanded' : 'collapsed',
      );
      toggleBtn.setAttribute('aria-expanded', shouldExpand ? 'true' : 'false');
      toggleBtn.textContent = shouldExpand ? 'See less' : 'See more';
    });
  });
}
